import { render } from "./PasswordResetCompleteScreen.vue?vue&type=template&id=ad8a330e&scoped=true&ts=true&lang=pug"
import script from "./PasswordResetCompleteScreen.vue?vue&type=script&lang=ts"
export * from "./PasswordResetCompleteScreen.vue?vue&type=script&lang=ts"

import "./PasswordResetCompleteScreen.vue?vue&type=style&index=0&id=ad8a330e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad8a330e"]])

export default __exports__